import { Tab } from "baseui/tabs-motion";
import * as React from "react";
import AdminConnection from "../../../pages/guides/2-actions-as-code/tutorials/shopify-connections/Admin-Connection.mdx";
import PartnersConnection from "../../../pages/guides/2-actions-as-code/tutorials/shopify-connections/Partners-Connection.mdx";
import { useDocsLocation } from "../../chrome/nav/useDocsLocation";
import { DocsTabs } from "../../markdown-components";
import { ConnectionDocsRouteProperties } from "./ConnectionDocsRouteProperties";

export const ShopifyConnectionTabs = ({
  admin,
  partners,
  cli,
  includeSyncDocs,
  showEventSubscriptions = true,
  gadgetScopeAndModelSelectionDoc,
  shopifyScopeSelectionDoc,
  partnersUrlImage,
}: {
  admin: boolean;
  partners: boolean;
  cli: boolean;
  includeSyncDocs: boolean;
  showEventSubscriptions: boolean;
  gadgetScopeAndModelSelectionDoc: React.ReactNode;
  shopifyScopeSelectionDoc: React.ReactNode;
  partnersUrlImage: React.ReactNode;
}) => {
  const [location] = useDocsLocation();
  const [activeTab, setActiveTab] = React.useState(0);

  // this is a bit hacky as it depends on the route name for initial render, but it works for now
  React.useEffect(() => {
    if ((admin && !partners) || location.includes(ConnectionDocsRouteProperties.cli.route)) {
      setActiveTab(1);
    }
  }, [partners, cli, admin, activeTab, location]);

  return (
    <DocsTabs activeTab={activeTab}>
      {partners && (
        <Tab title="Partners Connection">
          <PartnersConnection
            gadgetScopeAndModelSelectionDoc={gadgetScopeAndModelSelectionDoc}
            partnersUrlImage={partnersUrlImage}
            includeSyncDocs={includeSyncDocs}
            showEventSubscriptions={showEventSubscriptions}
          />
        </Tab>
      )}
      {admin && (
        <Tab title="Admin Connection">
          <AdminConnection
            gadgetScopeAndModelSelectionDoc={gadgetScopeAndModelSelectionDoc}
            shopifyScopeSelectionDoc={shopifyScopeSelectionDoc}
            includeSyncDocs={includeSyncDocs}
          />
        </Tab>
      )}
    </DocsTabs>
  );
};
